


























































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
   // import CreateOrderManagement from './create-ordermanagement.vue'
    import EditOrderDispose from './edit-orderdispose.vue'
    import Editordermanagement from './edit-ordermanagement.vue'
    import EditOrderSignFor from './edit-ordersignfor.vue'
    
    //出库订单末端管理
    class OrderManagementDisposeRequest extends PageRequest{
        keyword:string='';
        stime:Date;
        etime:Date;
        ordtime: Date[] = [];
        status:number=-1;
        type:number=2;
    }
    
    @Component({
        //components:{CreateOrderManagement,Editordermanagement,EditOrderDispose}
         components:{Editordermanagement,EditOrderDispose,EditOrderSignFor}
    })
    export default class ordermanagements extends AbpBase{
        edit(){
            this.editModalShow=true;
        }

        pagerequest:OrderManagementDisposeRequest=new OrderManagementDisposeRequest();

        createModalShow:boolean=false;
        editModalShow:boolean=false;
        createOrderDisposeShow:boolean=false;
        createOrderSignForShow:boolean=false;
        get list(){
            
            return this.$store.state.ordermanagement.list;
        };
        get loading(){
            return this.$store.state.ordermanagement.loading;
        }
        get tylist(){

            let tyls=[];
                var ls=this.$store.state.ordermanagement.ordertype;
                for(let i=0;i<ls.length;i++){
                     if(ls[i].id==2){
                            
                       tyls.push(ls[i]);
                     }

                }
                return tyls;


        }
        create(){
            
        

         this.$store.state.ordermanagement.type=3;
         this.$store.state.ordermanagement.isdispose=true;
         this.createModalShow=true;
        }
         createdispose(){
             
             
         this.createOrderDisposeShow=true;
         
        }
        createsignfor(){
            this.createOrderSignForShow=true;
        }


        pageChange(page:number){
            this.$store.commit('ordermanagement/setCurrentPage',page);
            this.getpage();
        }
        pagesizeChange(pagesize:number){
            this.$store.commit('ordermanagement/setPageSize',pagesize);
            this.getpage();
        }
         async searchpage(){
            this.$store.state.ordermanagement.currentPage=1;
           this. getpage();
        }
        async getpage(){
             
            //this.pagerequest.type=23;
            this.pagerequest.maxResultCount=this.pageSize;
            this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
            if (this.pagerequest.ordtime.length > 0) {
            this.pagerequest.stime = this.pagerequest.ordtime[0];
    }
    if (this.pagerequest.ordtime.length > 1) {
           this.pagerequest.etime = this.pagerequest.ordtime[1];
    }
 
            
            await this.$store.dispatch({
                type:'ordermanagement/getAll',
                data:this.pagerequest
            })
           
        }
        async updatestatus(id,status){
            
                  var  parm={ id :id,status:status};
            await this.$store.dispatch({
                type:'ordermanagement/updatestatus',
                data:parm
            })
        }
        async getCompanyInformation_All(){

              await this.$store.dispatch({
                type:'ordermanagement/getCompanyInformation',
                data:this.pagerequest
            })
        }
         async getWastetype_All(){

              await this.$store.dispatch({
                type:'ordermanagement/getWasteType',
                data:this.pagerequest
            })
        }



        get pageSize(){
            return this.$store.state.ordermanagement.pageSize;
        }
        get totalCount(){
            return this.$store.state.ordermanagement.totalCount;
        }
        get currentPage(){
            return this.$store.state.ordermanagement.currentPage;
        }
        columns=[{
            title:this.L('OrderNo'),
            key:'orderno'
        }
        /*
        ,{
            title:this.L('OrderType'),
           //key:'type'
            width:100,
            render:(h:any,params:any)=>{
                  var statustxt="";
                  var lstst=this.$store.state.ordermanagement.ordertype;
                   for(let i=0;i<lstst.length;i++){

                       if(lstst[i].id==params.row.type){
                            statustxt=this.L(lstst[i].name)
                             
                             
                         }
                   }
                      return    h('span',statustxt);
             }
        }*/
        
        ,{
            title:this.L('OrderWeight'),
            key:'weight',
            width:100
        }
        
,{
            title:this.L('CompanyinformationName'),
           // key:'orderTime'
             render:(h:any,params:any)=>{
         var name="";
                if(params.row.companyInformation!=null){
                      name=params.row.companyInformation.name;
                }    
                return h('span',name)
            }
        }
      ,{
            title:this.L('WasteTypeName'),
           
            width:120,
             render:(h:any,params:any)=>{
                //console.log(params.row)
                var wdname="";
                 if(params.row.  wasteType!=null){
                      wdname=params.row.  wasteType.wdname;
                }   
                return h('span',wdname)
            }
        }
      
        
        ,{
            title:this.L('OrderOperators'),
            key:'operators',
            width:120
        },{
            title:this.L('OrderStatus'),
            //key:'status'
            width:120,
             render:(h:any,params:any)=>{
                  var statustxt="";
                  var lstst=this.$store.state.ordermanagement.statuslist;
                   for(let i=0;i<lstst.length;i++){

                       if(lstst[i].id==params.row.status){
                            statustxt=this.L(lstst[i].name)
                            
                             
                         }
                   }
                      return    h('span',statustxt);
             }
        } 
        ,{
            title:this.L('OrderTime'),
           // key:'orderTime'
             render:(h:any,params:any)=>{
                //console.log(params.row)
                return h('span',new Date(params.row.ordertime).toLocaleString())
            }
        }
        ,{
            title:this.L('OrderSignforUpdateTime'),
           // key:'updatetime'
           render:(h:any,params:any)=>{
                //console.log(params.row)
                var  updatetime='';
                if(params.row.updatetime!=''&&params.row.updatetime!=null){

                   updatetime=  new Date(params.row.updatetime).toLocaleString()
                }
                return h('span',updatetime);
            }
        }
         ,{
            title:this.L('OrderSignfoOperators1'),
            key:'operators1',
            width:120
        }
          ,{
            title:this.L('OrderHandleUpdateTime'),
           // key:'updatetime'
           render:(h:any,params:any)=>{
                //console.log(params.row)
                var  updatetime1='';
                if(params.row.updatetime1!=''&&params.row.updatetime1!=null){

                   updatetime1=  new Date(params.row.updatetime1).toLocaleString()
                }
                return h('span',updatetime1);
            }
        }
        
        
        

        //
       ,{
            title:this.L('Actions'),
            key:'Actions',
            width:200,
            render:(h:any,params:any)=>{
                   let  atn=
                   [
                    h('Button',{
                        props:{
                            type:'primary',
                            size:'small'
                        },
                        style:{
                            marginRight:'5px'
                        },
                        on:{
                            click:()=>{
                                this.$store.commit('ordermanagement/edit',params.row);
                                this.edit();
                            }
                        }
                    },this.L('Edit'))];
                   /* h('Button',{
                        props:{
                            type:'error',
                            size:'small'
                        },
                      style:{
                            marginRight:'5px'
                       },
                        on:{
                            click:async ()=>{
                                this.$Modal.confirm({
                                        title:this.L('Tips'),
                                        content:this.L('DeleteConfirm'),
                                        okText:this.L('Yes'),
                                        cancelText:this.L('No'),
                                        onOk:async()=>{
                                            await this.$store.dispatch({
                                                type:'ordermanagement/delete',
                                                data:params.row
                                            })
                                            await this.getpage();
                                        }
                                })
                            }
                        }
                    },this.L('Delete'))];*/
                    //&&params.row.status!=2
                    if(params.row.type==2&&params.row.status==1||params.row.status==3){
                             //Signfor 签收
                             //Drying 处置
                              let st=3;
                             let lname='SignforBtn'
                             let confirmcnt="SignforConfirm";
                           
                             if(params.row.status==3){
                                lname='HandleBtn'
                                st=2;
                                  confirmcnt="ConfirmeHandle";
                             }

                             atn.push(
                                h('Button',{
                        props:{
                            type:'cancel',
                            size:'small'
                        },
                        on:{
                            click:async ()=>{
                                this.$Modal.confirm({
                                        title:this.L('Tips'),
                                        content:this.L(confirmcnt),
                                        okText:this.L('Yes'),
                                        cancelText:this.L('No'),
                                        onOk:async()=>{
                                          
               
                                             if(params.row.status==1){
                                               this.$store.commit('ordermanagement/edit',params.row);
                                                this.   createdispose();
                                               
                                             }else{
                                                  this.$store.commit('ordermanagement/edit',params.row);
                                                  this. createsignfor();
                                                       //this.updatestatus(params.row.id,st);
                                             }
                                            //   console.log( this.$store.state);
                                            
                                            setTimeout(() => {
  this.getpage();

}, 500);
                                           
                                        }
                                })
                            }
                        }
                    },this.L(lname))
                );

                    }



                return h('div',atn,
                  
                       )
            }
        }]
         async created(){
            this .pagerequest.type=2;
           // this.$store.state.ordermanagement.type=3;
            this.getpage();
            this.getWastetype_All()
            
              
        }

          currentTime() {
          let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
        hours: nowDate.getHours(),
        minutes: nowDate.getMinutes(),
        seconds: nowDate.getSeconds(),
      };      
      let newmonth = date.month > 10 ? date.month : "0" + date.month;
      let newday = date.date > 10 ? date.date : "0" + date.date;
      let newminutes = date.minutes < 10 ? "0" + date.minutes : date.minutes;
      let newseconds = date.seconds < 10 ? "0" + date.seconds : date.seconds;
      // 我需要的时间格式为 "yyyy-MM-dd HH:mm:ss" 有不一样的自己拼别的，都是字符串拼接
      let newTime =
        date.year +
        "-" +
        newmonth +
        "-" +
        newday +
        " " +
        date.hours +
        ":" +
        newminutes +
        ":" +
        newseconds;
        return newTime;
}
 
        
    }
